export const INIT_ERRORS_CONFIG = {
    project: 'vzhik',
    page: 'index',
    host: window.location.href,
    preventError: false,
    unhandledRejection: true,
    uncaughtException: true,
};
